import { DOCUMENT } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
  selector: 'app-platform-desktop',
  imports: [
    TranslatePipe,
    QRCodeComponent
  ],
  templateUrl: './desktop.html',
  styleUrl: './desktop.css',
})
export class Desktop {
  readonly credentialKey = input<string>();
  readonly qrcode = computed(() => {
    return this.document.location.protocol + '//' + this.document.location.host + '/' + this.credentialKey();
  });
  private readonly document = inject(DOCUMENT);
}
